<div
  class="section-card"
  [class.variant-feature]="variant === 'feature'"
  [class.variant-feature-second]="variant === 'feature-second'"
  [class.variant-info]="variant === 'info'"
  [class.variant-banner]="variant === 'banner'"
  [class.card-from-desktop]="cardFromDesktop"
  [class.hide-heading-mobile]="hideHeadingOnMobile"
  [class.image-right]="imageSide === 'right'"
  [class.has-arrow]="showArrow && variant !== 'feature' && variant !== 'feature-second' && variant !== 'banner'"
  [class.row-on-desktop]="displayRowOnDesktop"
  [style.--sc-padding]="padding || null"
  [style.--sc-radius]="radius || null"
  [style.--sc-gap]="gap || null"
  [style.--sc-shadow]="boxShadow || null"
  [style.--sc-border-color]="borderColor || null"  
>
  <!-- Illustration / image — feature and banner variants -->
  <div class="section-card__image" *ngIf="variant === 'feature' || variant === 'feature-second' || variant === 'banner'">
    <ng-content select="[sectionImage]"></ng-content>
  </div>

  <!-- Heading + projected content. `display: contents` on standard variants flattens
       this wrapper so the heading and content sit directly in the card's flex column. -->
  <div class="section-card__text">
    <div class="section-card__heading" *ngIf="title || subtitle">
      <div class="section-card__heading-row">
        <div class="section-card__title-group">
          <ng-content select="[sectionTitleImage]"></ng-content>
          <h2
            *ngIf="title"
            [class]="titleClass"
            [style.color]="titleColor || null"
            [style.font-size]="titleFontSize || null"
          >
            {{ title }}
          </h2>
        </div>
        <ng-content select="[sectionHeaderAction]"></ng-content>
      </div>
      <p
        *ngIf="subtitle"
        [class]="subtitleClass"
        [style.color]="subtitleColor || null"
        [style.font-size]="subtitleFontSize || null"
      >
        {{ subtitle }}
      </p>
    </div>
    <ng-content></ng-content>
  </div>

  <!-- Optional trailing forward arrow (learn-card style).
       Renders as <a> when a routerLink is provided; <button> otherwise so the element
       is always keyboard-focusable and semantically correct. -->
  <ng-container *ngIf="showArrow && variant !== 'feature' && variant !== 'feature-second' && variant !== 'banner'">
    <a
      *ngIf="arrowRouterLink; else arrowButton"
      class="section-card__arrow"
      [routerLink]="arrowRouterLink"
      [attr.aria-label]="arrowAriaLabel || null"
      (click)="arrowClick.emit()"
    >
      <img [src]="arrowIconSrc" alt="" />
    </a>
    <ng-template #arrowButton>
      <button
        class="section-card__arrow"
        type="button"
        [attr.aria-label]="arrowAriaLabel || null"
        (click)="arrowClick.emit()"
      >
        <img [src]="arrowIconSrc" alt="" />
      </button>
    </ng-template>
  </ng-container>

  <!-- Action (button / CTA / player) — feature variants only -->
  <div class="section-card__action" *ngIf="variant === 'feature' || variant === 'feature-second'">
    <ng-content select="[sectionAction]"></ng-content>
  </div>
</div>
